










import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    props:{
        value:String
    }
})
export default class Email extends Vue{
    @Prop({})
    value!:String;
    val:String=this.value;
}
